<template>
  <!-- Sign in Section start -->
  <section class="auth-page">
    <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="animation-circle">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="auth-card">
      <div class="text-center">
        <h2>Forgot Password</h2>
        <img
          src="../assets/images/title-line.png"
          alt="title-line"
          class="img-fluid line"
        />
      </div>
      <div class="main">
        <form class="auth-form">
          <div class="form-group">
            <label for="exampleInputEmail1">Email</label>
            <i class="fa fa-envelope-o"></i>
            <input
              required=""
              name="login[username]"
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              placeholder="Email"
            />
          </div>
          <div class="form-group">
            <button class="btn submit" type="submit">Send Code</button>
          </div>
          <div class="or-saparator"><span>or</span></div>
          <h6 class="text-center mt-0 mb-3">Sign in with:</h6>
          <div class="form-button text-center social-btns">
            <button class="btn submit fb">Sign in</button>
            <button class="btn submit ggl">Signup</button>
          </div>
        </form>
      </div>
    </div>
  </section>
  <!-- Sign in Section End -->
</template>
<script>
export default {
  name: "Forgotpassword",
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
};
</script>
